<template>
  <div class="registration">
    <h4 v-if="$route.path.match(new RegExp('^\/persons', 'i'))">
      {{ _.registration_statuses }}
    </h4>
    <h4 v-if="$route.path.match(new RegExp('^\/person/[0-9]+/edit', 'i'))">
      {{ _.registration_status }}
    </h4>
    <div v-if="$route.path.match(new RegExp('^\/persons', 'i'))" style="padding: 4px 12px;">
      <button v-if="in_progress === false" @click="updateRegistrationStatuses()">
        {{ _.update }}
      </button>
      <div v-if="in_progress === true">
        <button class="in_progress">
          {{ _.in_progress }} 
          <span v-if="status.total_attendees">{{ Math.round(((status.processed_attendees / status.total_attendees) * 50) + (status.processed_persons ? ((status.processed_persons / status.total_persons) * 50) : 0)) }} %</span>
          ...
        </button>
      </div>
    </div>
    <div class="last" v-if="in_progress === false && last && last.deleted_at">
      {{ _.last_updated }}: {{ lastUpdatedAt(last.deleted_at) }}
    </div>
    <div v-if="$route.path.match(new RegExp('^\/person/[0-9]+/edit', 'i'))" style="padding: 4px 12px;">
      <button @click="updateRegistrationStatus()">{{ _.update }}</button>
    </div>
  </div>
</template>

<script>
import { API_URL } from '@/config'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
export default {
  data() {
    return {
      polling: null,
      in_progress: null,
      status: null,
      last: null,
    }
  },
  computed: {
    ...mapGetters('persons', ['persons']),
    ...mapGetters('person', ['person']),
  },
  methods: {
    ...mapMutations('persons', ['clearList']),
    ...mapActions('persons', ['getList']),
    ...mapActions('person', ['getPerson']),
    ...mapActions('person_edit', ['getForm']),
    lastUpdatedAt(timestamp) {
      if (!timestamp) return '';
      return dayjs.utc(timestamp).local().format(this._.date_format_comments);
    },
    pollStatus() {
      if (this.polling) clearInterval(this.polling);
      this.polling = setInterval(() => {
        this.checkStatus();
      }, 5000)
    },
    async checkStatus() {
      const response = await this.axios.get(API_URL + '/persons/status');
      if (!response.data.status) {
        // this.clearList();
        // await this.getList();
        this.in_progress = false;
        this.status = false;
        this.last = response.data.last;
        return;
      }
      this.in_progress = true;
      this.status = response.data.status;
      this.last = response.data.last;
    },
    async updateRegistrationStatuses() {
      if (this.in_progress) return;
      this.in_progress = true;
      await this.axios.get(API_URL + '/persons/registration');
      this.pollStatus();
    },
    async updateRegistrationStatus() {
      if (this.in_progress) return;
      await this.axios.get(API_URL + '/persons/' + this.person.id + '/registration');
      await this.getPerson();
      await this.getForm();
      this.setProgress(false);
      this.in_progress = false;
    },
  },
  async created() {
    dayjs.extend(utc);
    await this.checkStatus();
    this.pollStatus();
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/variables.scss';
.registration {
  border-top: 1px solid lighten($primary-color, 80%);
  > div {
    > div {
      > button {
        margin-bottom: 6px;
        &.in_progress {
          cursor: default;
          color: rgba(#fff, .5);
          background-image: -webkit-linear-gradient(
            -45deg,
            $primary-color 25%,
            lighten($primary-color, 12%) 25%,
            lighten($primary-color, 12%) 50%,
            $primary-color 50%,
            $primary-color 75%,
            lighten($primary-color, 12%) 75%,
            lighten($primary-color, 12%)
          );
          background-size: 16px 16px;
          animation: in_progress .5s linear 0s infinite;
        }
        @keyframes in_progress {
          0% { background-position: 0 0; }
          100% { background-position: 16px 16px; }
        }
      }
    }
  }
  .last {
    padding: 12px 12px;
    font-size: 0.9em;
    color: darken($primary-color, 20%);
  }
}
</style>
